/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The type of feedback impression a user is allowed to submit for feedback.
 */
export var FeedbackImpressionOptions;
(function (FeedbackImpressionOptions) {
    FeedbackImpressionOptions["ADD_LIKE"] = "AddLike";
    FeedbackImpressionOptions["ADD_LIKE_MESSAGE"] = "AddLikeMessage";
    FeedbackImpressionOptions["REMOVE_LIKE"] = "RemoveLike";
    FeedbackImpressionOptions["ADD_DISLIKE"] = "AddDislike";
    FeedbackImpressionOptions["ADD_DISLIKE_MESSAGE"] = "AddDislikeMessage";
    FeedbackImpressionOptions["REMOVE_DISLIKE"] = "RemoveDislike";
})(FeedbackImpressionOptions || (FeedbackImpressionOptions = {}));
